angular.module('app').directive('selectCargo', function() {
	return {
        restrict: 'E',
        template: function($element, attrs){
            var html = `
            <select class="form-control" 
                chosen
                ng-options="x.id as x.nome for x in options" 
                ng-model="ngModel">
                <option value=""></value>
            </select>
        `;
        $jqueryElement = $(html);

            if(attrs.placeholder){
                $jqueryElement.attr('data-placeholder-text-single', "'"+attrs.placeholder+"'");
                $jqueryElement.find('option[value=""]').first().html(attrs.placeholder);
            }else{
                $jqueryElement.attr('data-placeholder-text-single', "' '");
            }

            if(attrs.required){
                $jqueryElement.attr('required', true);
            }

            return $jqueryElement[0].outerHTML;
        },
        scope: {
            ngModel: '=',
        },
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.options = [];

            $scope.getOptions = function(){
                var base = window.location.protocol+'//'+window.location.hostname;
                base = base.replace('politica.', '');

                $http({
                    'url': base+'/cargos/select'
                }).then(function(res){
                    $scope.options = res.data 
                });
            }
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.getOptions();
        }
    };
})